<template>
  <v-flex>
    <v-form v-model="valid" ref="form">
      <div class="d-flex">
        <v-switch
          v-if="sempreAtivo"
          v-model="switch1"
          :label="`Status: ${switch1 == true ? 'ATIVO' : 'BLOQUEADO'}`"
          :readonly="sempreAtivo"
        ></v-switch>
        <select-situacoes v-else></select-situacoes>
        <select-praca v-if="!sempreAtivo" class="mr-2"></select-praca>
      </div>
      <div class="d-flex">
        <v-text-field
          class="mr-2"
          label="CPF"
          name="CPF"
          placeholder="###.###.###-##"
          v-model="vendedor.cpf"
          v-mask="'###.###.###-##'"
          :rules="cpfRules"
          :error-messages="cpfValido == 'error_outline' ? 'CPF já cadastrado, consulte o cadastro de vendedores' : ''"
          :append-icon="cpfValido"
        ></v-text-field>
        <v-text-field
          class="mr-2"
          label="Nome"
          name="Nome"
          placeholder="Nome"
          v-model="vendedor.nome"
          :rules="nomeRules"
        ></v-text-field>
        <money class="mr-2" v-model="vendedor.totalDivida" v-bind="money"></money>
      </div>
      <div class="d-flex">
        <v-text-field class="mr-2" label="RG" name="RG" placeholder="RG" v-model="vendedor.rg"></v-text-field>
        <v-text-field
          class="mr-2"
          label="Telefone"
          name="Telefone"
          placeholder="(##) #####-####"
          v-model="vendedor.telefone1"
          v-mask="'(##) #####-####'"
          :rules="telefoneRules"
        ></v-text-field>
        <v-text-field
          class="mr-2"
          label="Telefone"
          name="Telefone"
          placeholder="(##) #####-####"
          v-model="vendedor.telefone2"
          v-mask="'(##) #####-####'"
        ></v-text-field>
        <v-menu
          class="pr-2"
          ref="dtNasc"
          lazy
          :close-on-content-click="false"
          v-model="dtNascimento"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-bottom="-22"
          max-width="290px"
          :return-value.sync="dataNascimento"
        >
          <v-text-field
            slot="activator"
            label="Data nascimento"
            v-model="dataNascimento"
            append-icon="event"
            :rules="nascimentoRules"
            readonly
          ></v-text-field>
          <v-date-picker v-model="dataNascimento" no-title scrollable locale="pt-br">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dtNascimento = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="formatData(dataNascimento)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </div>
      <div class="d-flex">
        <v-text-field
          class="mr-2"
          slot="activator"
          label="CEP"
          v-model="vendedor.cep"
          placeholder="CEP"
          @blur="buscaCep"
        ></v-text-field>
        <v-text-field
          class="mr-2"
          slot="activator"
          label="Cidade"
          v-model="vendedor.cidade"
          placeholder="Cidade"
        ></v-text-field>
        <v-text-field
          class="mr-2"
          slot="activator"
          label="Bairro"
          v-model="vendedor.bairro"
          placeholder="Bairro"
        ></v-text-field>
      </div>
      <div class="d-flex">
        <v-text-field class="mr-2" slot="activator" label="Rua" v-model="vendedor.rua" placeholder="Rua"></v-text-field>
        <v-text-field
          class="mr-2"
          slot="activator"
          label="Número"
          v-model="vendedor.numero"
          placeholder="Número"
        ></v-text-field>
        <v-text-field
          class="mr-2"
          slot="activator"
          label="Estado"
          v-model="vendedor.uf"
          placeholder="Estado"
        ></v-text-field>
      </div>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark text @click="cancelar()">Cancelar</v-btn>
      <v-btn color="primary" dark text @click="salvarVendedor()">Salvar</v-btn>
    </v-card-actions>
  </v-flex>
</template>
<script>
import { VMoney, Money } from "v-money"
import { serverBus } from "../../main"
import EditarVendedor from "../../domain/vendedor/EditarVendedor"
import SelectSituacoes from "../vendedor/selectSituacaoVendedor"
import SelectPraca from "../praca/selectPracaPorFuncionario.vue"
import { ServicoVendedor } from "../../servicos/servicoVendedor"
import { ServicoConsultaCep } from "../../servicos/servicoConsultaCep"
const servicoVendedor = new ServicoVendedor()
const servicoConsultaCep = new ServicoConsultaCep()
export default {
  directives: { money: VMoney },
  components: {
    SelectPraca,
    SelectSituacoes,
    Money
  },
  data() {
    return {
      id: null,
      dtNascimento: false,
      dataNascimento: null,
      vendedor: new EditarVendedor(),
      switch1: true,
      cpfValido: "",
      cepEncontrado: true,
      nascimentoRules: [v => !!v || "Campo obrigatório"],
      nomeRules: [v => !!v || "Campo obrigatório"],
      cpfRules: [v => !!v || "Campo obrigatório"],
      telefoneRules: [v => !!v || "Campo obrigatório"],
      sempreAtivo: false,
      codPraca: "",
      valid: true,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " # Total da dívida",
        precision: 2,
        masked: false
      }
    }
  },
  created() {
    serverBus.$on("pracaSelected", value => {
      this.codPraca = value
    })
    serverBus.$on("sempreAtivo", value => {
      this.sempreAtivo = true
      this.codPraca = value
    })
    serverBus.$on("situacaoSelected", value => {
      this.vendedor.situacao = value
    })

    if (this.$route && this.$route.params) {
      this.id = this.$route.params.id
    }
    if (this.id) {
      servicoVendedor.buscarPorId(this.id).then(res => {
        if (res.status === 200 && res.data.length === undefined) {
          this.id = res.data.id
          this.vendedor.id = res.data.id
          this.vendedor.situacao = res.data.situacaoId
          this.vendedor.codPraca = res.data.idPraca
          this.codPraca = res.data.idPraca
          this.vendedor.cpf = res.data.cpf
          this.vendedor.nome = res.data.nome
          this.vendedor.rg = res.data.rg
          this.vendedor.telefone1 = res.data.telefone1
          this.vendedor.telefone2 = res.data.telefone2
          this.formatDataDatePickerParterner(res.data.dtNascimento)
          this.vendedor.cep = res.data.cep
          this.vendedor.cidade = res.data.cidade
          this.vendedor.bairro = res.data.bairro
          this.vendedor.rua = res.data.rua
          this.vendedor.numero = res.data.numero
          this.vendedor.uf = res.data.estado
          this.vendedor.totalDivida = res.data.totalDivida

          serverBus.$emit("carregarSituacaoSelecionada", this.vendedor.situacao)
          serverBus.$emit("carregarPracaSelecionada", this.vendedor.codPraca)
        }
      })
    }
  },
  methods: {
    validaCpfCadastrado() {
      if (this.vendedor.cpf) {
        servicoVendedor.validarCPFjaExiste(this.vendedor.cpf).then(res => {
          if (res.status === 200) {
            if (res.data) {
              this.cpfValido = "done_outline"
            } else {
              this.cpfValido = "error_outline"
            }
          }
        })
      }
    },
    buscaCep() {
      var cep = this.vendedor.cep
      servicoConsultaCep.buscaCep(cep).then(res => {
        if (res.status === 200 && res.data.erro == undefined) {
          this.vendedor.rua = res.data.logradouro
          this.vendedor.bairro = res.data.bairro
          this.vendedor.cidade = res.data.localidade
          this.vendedor.uf = res.data.uf
          this.cepEncontrado = true
        } else {
          this.vendedor.rua = ""
          this.vendedor.bairro = ""
          this.vendedor.cidade = ""
          this.vendedor.uf = ""
          this.cepEncontrado = false
        }
      })
    },
    salvarVendedor() {
      this.vendedor.codPraca = this.codPraca
      if (this.sempreAtivo) {
        this.vendedor.situacao = 1
      }

      if (this.$refs.form.validate()) {
        servicoVendedor.editarVendedor(this.vendedor).then(res => {
          if (res.status === 200) {
            if (this.sempreAtivo) {
              this.fecharDialog()
              serverBus.$emit("mensagemSucesso", true)
            } else {
              this.$router.push({ name: "Vendedores" })
            }
          }
        })
      }
    },
    cancelar() {
      if (this.sempreAtivo) {
        this.fecharDialog()
      } else {
        this.$router.push({ name: "Vendedores" })
      }
    },
    fecharDialog() {
      serverBus.$emit("fecharDialog", false)
    },
    formatData(dataNascimento) {
      if (dataNascimento != null) {
        var parts = dataNascimento.split("-")
        //var dataFormatada = parts[2] + '/' + parts[1] + '/' + parts[0]
        this.vendedor.dataNascimento = new Date(parts[0], parts[1] - 1, parts[2])
        this.$refs.dtNasc.save(dataNascimento)
      }
    },
    formatDataDatePickerParterner(data) {
      if (data != null && data != "") {
        var parts = data.split("/")
        var dataFormatada = parts[2] + "-" + parts[1] + "-" + parts[0]
        this.vendedor.dataNascimento = new Date(parts[2], parts[1] - 1, parts[0])
        this.dataNascimento = dataFormatada
        this.$refs.dtNasc.save(dataFormatada)
      }
    }
  }
}
</script>
